import { SlotStudentAttendance } from '@/plugins/api'

export default {
  namespaced: true,
  state: {
    slotStudentAttendances: [],
    totalCount: 0,
  },
  actions: {
    async fetch({ commit }, params) {
      const slotStudentAttendances = await SlotStudentAttendance.fetch(params)
      commit('changeState', { slotStudentAttendances })
      return slotStudentAttendances
    },
    async count({ commit }, params) {
      const count = await SlotStudentAttendance.count(params)
      commit('changeState', { count })
    },
    async update({ commit }, { id, ...data }) {
      await SlotStudentAttendance.update(id, data)
    },
    async updateMany({ commit }, data) {
      await SlotStudentAttendance.updateMany(data)
    },
  },
  mutations: {},
  getters: {
    slotStudentAttendances: (state) => state.slotStudentAttendances,
    totalCount: (state) => state.totalCount,
  },
}
